import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { httpClient } from '../core';
import { TranslatedFileModel } from '../models/file.model';
import { env } from '@/env';

export interface TranslationsState {
    isFetchingTranslations: boolean;
    isFetchingAllTranslations: boolean;
    translatedDocuments: TranslatedFileModel[];
    allDocuments: TranslatedFileModel[];
    numberOfDocumentsTranslated: number;
}

export const state: TranslationsState = {
    isFetchingTranslations: false,
    isFetchingAllTranslations: false,
    translatedDocuments: [],
    allDocuments: [],
    numberOfDocumentsTranslated: 0
};

export const getters: GetterTree<TranslationsState, any> = {
    getTranslatedDocuments: () => {
        return state.translatedDocuments;
    },
    isFetchingTranslations: () => {
        return state.isFetchingTranslations;
    },
    getAllDocuments: () => {
        return state.allDocuments;
    },
    isFetchingAllTranslations: () => {
        return state.isFetchingAllTranslations;
    },
};

export const mutations: MutationTree<TranslationsState> = {
    SET_TRANSLATED_DOCUMENTS(stateParam, translationsParams: []) {
        stateParam.translatedDocuments = translationsParams;
        stateParam.isFetchingTranslations = false;
        stateParam.numberOfDocumentsTranslated = translationsParams.length;
    },
    SET_FETCHING_TRANSLATIONS(stateParam) {
        stateParam.isFetchingTranslations = true;
    },
    UNSET_FETCHING_TRANSLATIONS(stateParam) {
        stateParam.isFetchingTranslations = false;
    },

    SET_TRANSLATED_ALL_DOCUMENTS(stateParam, translationsParams: []) {
        stateParam.allDocuments = translationsParams;
    },
    SET_FETCHING_ALL_TRANSLATIONS(stateParam) {
        stateParam.isFetchingAllTranslations = true;
    },
    UNSET_FETCHING_ALL_TRANSLATIONS(stateParam) {
        stateParam.isFetchingAllTranslations = false;
    },
};

export const actions: ActionTree<TranslationsState, any> = {
    fetchTranslations: ({commit}, payload) => {
        return new Promise((resolve, reject) => {
            commit('SET_FETCHING_TRANSLATIONS');
            let takepart = '';
            if(payload && payload.take) {
              takepart = `?take=${payload.take}`;
            }
            httpClient.instance.get(`${env.apiUrl}/documents/${env.applicationId}${takepart}`)
            .then((translationsResponse) => {
                commit('SET_TRANSLATED_DOCUMENTS', translationsResponse.data);
                resolve(translationsResponse);
            })
            .catch((error) => {
                // eslint-disable-next-line
                console.error("Error fetching translations " + error);
                reject(error);
            })
            .finally(() => {
                commit('UNSET_FETCHING_TRANSLATIONS');
            });
        });
    },

    //mode=global
    fetchAllDocuments: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('SET_FETCHING_ALL_TRANSLATIONS');
            httpClient.instance.get(`${env.apiUrl}/documents/${env.applicationId}/all`)
            .then((translationsResponse) => {
                commit('SET_TRANSLATED_ALL_DOCUMENTS', translationsResponse.data);
                resolve(translationsResponse);
            })
            .catch((error) => {
                // eslint-disable-next-line
                console.error("Error fetching ALL translations " + error);
                reject(error);
            })
            .finally(() => {
                commit('UNSET_FETCHING_ALL_TRANSLATIONS');
            });
        });
    }
};

export const translations: Module<TranslationsState, any> = {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
};
